module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "to-categories"
  }, [_c('div', {
    staticClass: "to-categories-container"
  }, [_c('div', {
    staticClass: "to-categories__header"
  }, [_c('h3', [_vm._v("Opgaveoversigt kategorier " + _vm._s(_vm.schoolYear.name))]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": function($event) {
        return _vm.$emit('setCreateCategory', true)
      }
    }
  }, [_vm._v("\n        Opret ny kategori\n      ")])]), _vm._v(" "), (_vm.taskCategories.length < 1) ? _c('h4', {
    staticClass: "text-explainer"
  }, [_vm._v("Ingen kategorier")]) : _vm._e(), _vm._v(" "), _c('draggable', {
    on: {
      "change": _vm.onChangeOrder
    },
    model: {
      value: (_vm.taskCategoriesOrder),
      callback: function($$v) {
        _vm.taskCategoriesOrder = $$v
      },
      expression: "taskCategoriesOrder"
    }
  }, [_c('transition-group', {
    attrs: {
      "type": "transition",
      "name": "flip-list",
      "tag": "ul"
    }
  }, _vm._l((_vm.taskCategoriesOrder), function(taskCategory, key) {
    return _c('li', {
      key: taskCategory.id,
      staticClass: "to-categories-container__category__container"
    }, [_c('div', {
      staticClass: "to-categories-container__category"
    }, [_c('div', [_c('div', {
      staticClass: "to-categories-container__category__number"
    }, [_c('span', [_vm._v(_vm._s(key + 1))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: false,
          placement: 'top',
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window'
        }),
        expression: "{\n                    arrow: false,\n                      placement : 'top',\n                      animation : 'shift-away',\n                      zIndex: '999999992',\n                      boundary: 'window'\n                }"
      }],
      staticClass: "icon__bg-circle icon__bg-circle--move",
      attrs: {
        "content": 'Flyt op eller ned for at sortere'
      }
    }, [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 572.156 572.156"
      },
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "version": "1.1",
        "id": "Capa_1",
        "x": "0px",
        "y": "0px",
        "width": "13px",
        "height": "13px",
        "viewBox": "0 0 572.156 572.156",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('polygon', {
      attrs: {
        "points": "495.405,241.769 418.657,197.457 418.657,258.115 314.042,258.115 314.042,153.498 374.699,153.498    330.389,76.751 286.078,0 241.769,76.751 197.457,153.498 258.115,153.498 258.115,258.115 153.498,258.115 153.498,197.457    76.751,241.767 0,286.078 76.751,330.387 153.498,374.699 153.498,314.042 258.115,314.042 258.115,418.657 197.457,418.657    241.767,495.405 286.078,572.156 330.387,495.405 374.699,418.657 314.042,418.657 314.042,314.042 418.657,314.042    418.657,374.699 495.405,330.389 572.156,286.078  "
      }
    })]), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g')])])]), _vm._v(" "), _c('div', {
      staticClass: "to-categories-container__category__text"
    }, [(_vm.getIsTheEditTask(taskCategory)) ? _c('div', {
      staticClass: "to-input-and-button"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.theEditTask.name),
        expression: "theEditTask.name"
      }, {
        name: "focus",
        rawName: "v-focus"
      }],
      staticClass: "d-input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.theEditTask.name)
      },
      on: {
        "keyup": [function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.saveEditTask.apply(null, arguments)
        }, function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
          $event.stopPropagation();
          return _vm.setEditTask(null)
        }],
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.theEditTask, "name", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "do-bttn do-bttn--submit",
      class: {
        'do-bttn--submit--loading': _vm.theUpdatingTaskId === taskCategory.id
      },
      on: {
        "click": _vm.saveEditTask
      }
    }, [_vm._v("Gem\n                  ")]), _vm._v(" "), _c('button', {
      staticClass: "do-bttn",
      on: {
        "click": function($event) {
          return _vm.setEditTask(null)
        }
      }
    }, [_vm._v("Annuller")]), _vm._v(" "), (taskCategory.v_is_used_on_subjects.length === 0) ? _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: false,
          placement: 'top',
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window'
        }),
        expression: "{\n                        arrow: false,\n                      placement : 'top',\n                      animation : 'shift-away',\n                      zIndex: '999999992',\n                      boundary: 'window'\n                    }"
      }],
      staticClass: "icon__bg-circle icon__bg-circle--danger",
      attrs: {
        "content": _vm.$t('vue2.common.delete')
      },
      on: {
        "click": function($event) {
          return _vm.setTheDeleteTaskCategory(taskCategory)
        }
      }
    }, [_c('span', {
      staticClass: "icon-bin"
    })]) : _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: false,
          placement: 'top',
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window'
        }),
        expression: "{\n                  arrow: false,\n                  placement : 'top',\n                  animation : 'shift-away',\n                  zIndex: '999999992',\n                  boundary: 'window'\n                }"
      }],
      staticClass: "icon__bg-circle icon__bg-circle--danger cursor-not-allowed",
      attrs: {
        "content": 'Kan ikke slettes, da den bruges på ' + taskCategory.v_is_used_on_subjects.length + ' fag/opgaver'
      }
    }, [_c('span', {
      staticClass: "icon-bin",
      staticStyle: {
        "opacity": "0.5"
      }
    })])]) : [_vm._v("\n                  " + _vm._s(taskCategory.name) + "\n                  "), _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: false,
          placement: 'top',
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window'
        }),
        expression: "{\n                  arrow: false,\n                  placement : 'top',\n                  animation : 'shift-away',\n                  zIndex: '999999992',\n                  boundary: 'window'\n                }"
      }],
      staticClass: "icon__bg-circle",
      attrs: {
        "content": _vm.$t('vue2.common.edit')
      },
      on: {
        "click": function($event) {
          return _vm.setEditTask(taskCategory)
        }
      }
    }, [_c('span', {
      staticClass: "icon-pencil"
    })])]], 2)]), _vm._v(" "), _c('div', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedItem),
        expression: "selectedItem"
      }],
      staticClass: "do-select",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.selectedItem = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          return _vm.onAddSubjectType(taskCategory, $event.target.value)
        }]
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "selected": "",
        "value": "null"
      }
    }, [_vm._v("Tilføj briktype til kategorien")]), _vm._v(" "), _vm._l((_vm.getFilteredDbSubjectTypes(taskCategory)), function(option) {
      return _c('option', {
        domProps: {
          "value": option.key
        }
      }, [_vm._v("\n                  " + _vm._s(option.v_title) + "\n                ")])
    })], 2)])]), _vm._v(" "), _c('ul', {
      ref: "droppable_elements",
      refInFor: true,
      staticClass: "to-categories-container__category__subject-types dropzone",
      class: {
        'dropzone--active': _vm.dragEvt && _vm.draggedFromCategoryId !== taskCategory.id
      },
      on: {
        "dragover": function($event) {
          $event.preventDefault();
        },
        "dragenter": function($event) {
          $event.preventDefault();
          return _vm.dragEnter(taskCategory, $event)
        },
        "dragleave": function($event) {
          $event.preventDefault();
          return _vm.dragLeave.apply(null, arguments)
        },
        "drop": function($event) {
          $event.preventDefault();
          return _vm.drop(taskCategory, $event)
        }
      }
    }, [(taskCategory.v_subject_types.length === 0) ? _c('li', {
      staticClass: "text-explainer"
    }, [_vm._v("Ingen kategorier")]) : _vm._e(), _vm._v(" "), _vm._l((taskCategory.v_subject_types), function(subjectType) {
      return _c('li', {
        key: subjectType.key,
        staticClass: "d-tag cursor-grab",
        attrs: {
          "draggable": "true"
        },
        on: {
          "dragstart": function($event) {
            $event.stopPropagation();
            return _vm.dragStart(subjectType, taskCategory.id, $event)
          },
          "dragend": function($event) {
            $event.stopPropagation();
            return _vm.dragEnd(subjectType, $event)
          },
          "dragover": function($event) {
            $event.stopPropagation();
          },
          "drop": function($event) {
            $event.preventDefault();
            return _vm.drop(taskCategory, $event)
          }
        }
      }, [_vm._v("\n              " + _vm._s(subjectType.v_name) + "\n            ")])
    })], 2)])
  }), 0)], 1)], 1), _vm._v(" "), (_vm.theDeleteTaskCategory) ? _c('DModal', {
    staticStyle: {
      "z-index": "123123"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": false,
      "placeInTop": true,
      "appendToBody": true,
      "isCloseOnEsc": true
    },
    on: {
      "close": function($event) {
        return _vm.setTheDeleteTaskCategory(null)
      }
    }
  }, [_c('div', {
    staticClass: "brutto-warning text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "brutto-warning__header"
  }, [_c('h2', [_vm._v("Er du sikker")]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle doc-modal__close",
    on: {
      "click": function($event) {
        return _vm.setTheDeleteTaskCategory(null)
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "brutto-warning__body"
  }, [_c('svg', {
    staticClass: "tw-icon tw-icon--red",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "9",
      "x2": "12",
      "y2": "13"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "17",
      "x2": "12.01",
      "y2": "17"
    }
  })]), _vm._v(" "), (_vm.theDeleteTaskCategory.v_subject_types && _vm.theDeleteTaskCategory.v_subject_types.length > 0) ? [_c('h4', [_vm._v("Før du kan slette denne kategori, skal du vælge en ny kategori til dens standard briktyper.")]), _vm._v(" "), _c('ul', {
    staticClass: "list-order-items"
  }, _vm._l((_vm.theDeleteTaskCategory.v_subject_types), function(subjectType) {
    return _c('li', {
      key: subjectType.key
    }, [_c('b', [_vm._v(_vm._s(subjectType.v_name))]), _vm._v(" "), _c('select', {
      staticClass: "do-select",
      domProps: {
        "value": null
      },
      on: {
        "change": function($event) {
          return _vm.onChangeCategoryForSubjectType($event.target.value, subjectType.key)
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": ""
      },
      domProps: {
        "value": null
      }
    }, [_vm._v("Vælg ny kategori..")]), _vm._v(" "), _vm._l((_vm.getTaskCategoriesOrder), function(option) {
      return _c('option', {
        domProps: {
          "value": option.id
        }
      }, [_vm._v("\n                  " + _vm._s(option.name) + "\n                ")])
    })], 2)])
  }), 0)] : _c('p', {
    staticClass: "text-explainer"
  }, [_vm._v("\n          Vil du slette kategorien permanent?\n        ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "brutto-warning__footer"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.setTheDeleteTaskCategory(null)
      }
    }
  }, [_vm._v("Annullér")]), _vm._v(" "), (_vm.theDeleteTaskCategory.v_subject_types.length > 0) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
  }, [_vm._v("Slet\n        ")]) : _c('button', {
    staticClass: "do-bttn do-bttn--submit do-bttn--danger",
    class: [{
      'do-bttn--submit--loading': _vm.theDeletedCategoryId === _vm.theDeleteTaskCategory.id
    }],
    on: {
      "click": function($event) {
        return _vm.deleteTaskCategory(_vm.theDeleteTaskCategory)
      }
    }
  }, [_vm._v("Slet\n        ")])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-90a5b738!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TaskOverviewSettings/TaskOverviewSettingsCategories.vue
// module id = 1722
// module chunks = 1